import { createFileRoute, redirect } from '@tanstack/react-router'
import { find } from 'lodash/fp'

import { Tag } from '@masterplandev/ui'

import { LoadingIndicator } from '@/core/components/LoadingIndicator'
import { FEATURE_DASHBOARD_CHANNELS } from '@/core/constants/features'
import useTranslation from '@/core/hooks/useTranslation'
import { channelsQueries } from '@/http/api/channels'
import { TopicPage } from '@/topic/components/TopicPage/TopicPage'
import { TopicPageContent } from '@/topic/components/TopicPageContent/TopicPageContent'

export const Route = createFileRoute('/_learning/channel/$channel/$topic/')({
  beforeLoad: ({ context: { user } }) => {
    if (!user?.features.includes(FEATURE_DASHBOARD_CHANNELS)) {
      throw redirect({ to: '/home' })
    }
  },
  loader: async ({ context: { queryClient } }) => {
    const channelsList = await queryClient.ensureQueryData(
      channelsQueries.list(),
    )
    return channelsList
  },
  component: RouteComponent,
  pendingComponent: () => <LoadingIndicator size="xl" />,
})

function RouteComponent() {
  const { translate } = useTranslation('')
  const params = Route.useParams()
  const { channels = [] } = Route.useLoaderData()

  const channelName =
    find({ slug: params.channel }, channels)?.title ||
    translate(`channels.${params.channel}.title`)

  return (
    <TopicPage>
      <TopicPageContent
        context="channel"
        extraInfo={
          <Tag variant="outline" mb="4" size="lg">
            {channelName}
          </Tag>
        }
        channelSlug={params.channel}
        topicSlug={params.topic}
      />
    </TopicPage>
  )
}
